<template>
  <div id="Home">
    <div class="component" :class="{full:full}">
      <component :is="componentName"/>
      <div class="shrink"
           v-if="tag=='ReportForm'||tag=='EnergyReportForm'||tag=='pvReportForm'||$store.state.project.pileIsSelect==1">
        <div class="arrow" v-if="arrowShow">点击可展开工作台 <i class="el-icon-close" @click="arrowShow=!arrowShow"></i><img
            src="@/assets/img/ri.png" alt=""></div>
        <div @click="full=!full">
          <span class="right" v-if="full"></span>
          <span class="left" v-else></span>
        </div>
      </div>
      <div class="close" @click="closedPage" v-if="routeName=='Overview'&&tag!='SubstationManagement'"><i
          class="el-icon-close"></i></div>
      <!-- <div style="height:100%" >
           <Loading LoadingId="componentShowLoading" :scale="0.5"   />
       </div> -->
    </div>
    <div class="publicright" :class="{full:full}" v-if="routeName=='WorkBench'">
      <workSideNav></workSideNav>
    </div>
    <div class="publicright" v-else>
      <div class="subcontainer-two">
        <Park></Park>
      </div>
      <div class="subcontainer-four">
        <EnergyDensity v-if="routeName=='EnergyConsumption'"/>
        <MeterStatus v-else-if="routeName=='PaymentMeter'"/>
        <Dynamic v-else-if="routeName=='Chargingpile'"></Dynamic>
        <Selling v-else-if="routeName=='PowerStation'"></Selling>
        <!-- <Monitor v-else-if="projectId==18||projectId==1||projectId==19||projectId==13"></Monitor>
        <MonitorRTC v-else></MonitorRTC> -->
        <Today></Today>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../../components/common/Loading.vue'
import Park from "../../components/common/Park";
import Monitor from "../../components/common/Monitor";
import MonitorRTC from "../../components/common/MonitorRTC";
import PowerWiringLine from "../../components/common/PowerWiringLine";
import Overview from "../Overview/SubstationManagement";
import Photovoltaic from "../Photovoltaic/index";
import PowerDistribution from "../PowerDistribution/index";
import WorkBench from "../WorkBench/Homepage";
import workSideNav from "./components/workSideNav";
import WiringLine from "../PowerDistribution/components/WiringLine";
import pvWiringLine from "../Photovoltaic/components/pvWiringLine";
import ReportForm from "../ReportForm/Index";
import Comparison from "../Comparison/index";
import EnergyConsumption from "../EnergyConsumption/index";
import Savingplan from "../Savingplan/index";
import PaymentMeter from "../PaymentMeter/index";
import EventManagement from "../EventManagement/index";
import EnergyDensity from '../EnergyConsumption/components/EnergyDensity'
import CapacitanceCompensation from "../PowerQuality/CapacitanceCompensation";
import MeterStatus from "../PaymentMeter/components/MeterStatus";
import SwitchControl from "../SwitchControl/index";
import loopControl from "../loopControl/index";
import MeterReading from "../MeterReading/index";
import EquipmentAccount from "../EquipmentAccount/index";
import PowerMonitoring from "../PowerMonitoring/index";
import EnergyReport from "../EnergyReport/index";
import EnergyReportForm from "../EnergyReportForm/index";
import InverterMonitoring from "../InverterMonitoring/index";
import LoopMonitoring from "../LoopMonitoring/index";
import CommunicationStatus from "../CommunicationStatus/index";
import UPS from "../UPS/index";
import Chargingpile from "../Chargingpile/index";
import Piles from "../Piles/index.vue";
import Dynamic from "../Chargingpile/components/Dynamics"
import MakerMonitor from "../MakerMonitor/index"
import Today from "../../components/common/Today";
import Police from "../Police/index";
import PowerStation from "../PowerStation/index";
import Selling from "../PowerStation/components/Selling";
import ChargingLedger from "../ChargingLedger/index.vue";
import ChargingPileMonitoring from "../ChargingPileMonitoring/index";

export default {
  data() {
    return {
      path: "",
      full: false,
      arrowShow: false
    }
  },
  components: {
    Loading,
    Park,
    Monitor,
    MonitorRTC,
    Photovoltaic,
    PowerDistribution,
    Overview, WorkBench,
    workSideNav,
    WiringLine,
    pvWiringLine,
    ReportForm,
    Comparison,
    EnergyConsumption,
    CapacitanceCompensation,
    EnergyDensity,
    Savingplan,
    PaymentMeter,
    MeterStatus,
    EventManagement,
    PowerWiringLine,
    SwitchControl,
    MeterReading,
    EquipmentAccount,
    PowerMonitoring,
    EnergyReport,
    EnergyReportForm,
    InverterMonitoring,
    ChargingPileMonitoring,
    LoopMonitoring,
    CommunicationStatus,
    UPS,
    Chargingpile,
    Dynamic,
    Piles,
    MakerMonitor,
    Today,
    loopControl,
    Police,
    PowerStation,
    Selling,
    ChargingLedger
  },
  computed: {
    tag() {
      console.log(this.$route.params.tag)
      if (this.$route.params.tag == 'ReportForm' ||
          this.$route.params.tag == 'EnergyReportForm' ||
          this.$route.params.tag == 'pvReportForm'
      ) {
        this.full = true
        this.arrowShow = true
        let self = this
        setTimeout(function () {
          self.arrowShow = false
        }, 3000)
      } else {
        this.full = false
      }
      return this.$route.params.tag
    },
    routeName() {
      return this.$route.params.name;
    },
    componentName() {
      switch (this.$route.params.tag) {
        case "WiringLine":
          return 'WiringLine';
        case "pvWiringLine":
          return 'pvWiringLine';
        case "ReportForm":
          return 'ReportForm';
        case "pvReportForm":
          return 'ReportForm';
        case "Comparison":
          return 'Comparison';
        case "CapacitanceCompensation":
          return 'CapacitanceCompensation';
        case "Savingplan":
          return 'Savingplan';
        case "EventManagement":
          return 'EventManagement';
        case "PowerWiringLine":
          return 'PowerWiringLine';
        case "SwitchControl":
          return 'SwitchControl';
        case "loopControl":
          return 'loopControl';
        case "MeterReading":
          return 'MeterReading';
        case "EquipmentAccount":
          return 'EquipmentAccount';
        case "PowerMonitoring":
          return 'PowerMonitoring';
        case "EnergyReport":
          return 'EnergyReport';
        case "EnergyReportForm":
          return 'EnergyReportForm';
        case "InverterMonitoring":
          return 'InverterMonitoring';
        case "ChargingPileMonitoring":
          return 'ChargingPileMonitoring';
        case "LoopMonitoring":
          return 'LoopMonitoring';
        case "CommunicationStatus":
          return 'CommunicationStatus';
        case "UPS":
          return 'UPS';
        case "MakerMonitor":
          return 'MakerMonitor';
        case "Piles":
          return 'Piles';
        case "Police":
          return 'Police';
        case "ChargingLedger":
          return 'ChargingLedger';
      }
      switch (this.$route.params.name) {
        case "Overview":
          return 'Overview';
        case "Photovoltaic":
          return 'Photovoltaic';
        case "PowerDistribution":
          return 'PowerDistribution';
        case "WorkBench":
          return 'WorkBench';
        case "EnergyConsumption":
          return 'EnergyConsumption';
        case "PaymentMeter":
          return 'PaymentMeter';
        case "Chargingpile":
          return 'Chargingpile';
        case "Police":
          return 'Police';
        case "PowerStation":
          return 'PowerStation';
      }
    },
    projectId() {
      return this.$store.getters.projectId
    },
  },
  watch: {
    $route(n, o) {
      // if(n.params.tag=='Homepage'){  //工作台默认选中第一个
      //     debugger
      //     this.$router.push(this.$store.state.project.FirstPage.url)
      //     this.$store.commit("setCurrWorkBench",this.$store.state.project.FirstPage.url)
      // }
    },
    "$store.state.project.FirstPage"(n, o) {
      if (this.$route.params.tag == 'Homepage') {
        this.$router.push(n.url)
        this.$store.commit("setCurrWorkBench", n.url)
      }
    },
    "$store.state.project.pileIsSelect": {
      handler(n, o) {
        if (n === 1) {
          console.log(n)
          this.full = true
          this.arrowShow = true
          let self = this
          setTimeout(function () {
            self.arrowShow = false
          }, 3000)
        } else {
          this.full = false
        }
      },
      immediate: true,
      deep: true
      // if (this.$route.params.tag == 'Homepage') {
      //   this.$router.push(n.url)
      //   this.$store.commit("setCurrWorkBench", n.url)
      // }
    }
  },
  mounted() {
    if (this.$route.params.tag == 'ReportForm' || this.$route.params.tag == 'EnergyReportForm') {
      this.full = true
      this.arrowShow = true
      let self = this
      setTimeout(function () {
        self.arrowShow = false
      }, 3000)
    } else {
      this.full = false
    }
  },
  methods: {
    closedPage() {
      this.$router.push("/Home/Overview/SubstationManagement")
    }
  }
}
</script>

<style lang="less" scoped>
#Home {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-between;
  align-content: space-between;

  .component {
    .w(1194);
    height: 100%;
    position: relative;
    transition: 0.3s;
  }

  .component.full {
    width: 100%;
  }

  .publicright.full {
    width: 0;
  }

  .close {
    position: absolute;
    right: 10px;
    top: 10rem;
    cursor: pointer;
    z-index: 1;

    i {
      font-size: 24px;
      font-weight: bold;
    }
  }

  .shrink {
    position: absolute;
    left: 100%;
    top: 45%;
    width: 13px;
    height: 65px;
    line-height: 65px;
    background: #B6BDC4;
    border: 1px solid #A8AFB7;
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    z-index: 23;

    .arrow {
      position: absolute;
      right: 28px;
      top: 15px;
      border-radius: 6px;
      width: 180rem;
      height: 41rem;
      line-height: 41rem;
      font-size: 16rem;
      background: rgba(0, 0, 0, 0.04);
      border: 1px solid #E5E5E5;
      padding-right: 5px;

      i {
        color: #666666;
        font-size: 20px;
        vertical-align: middle;
        float: right;
        margin-top: 7px;
      }

      img {
        position: absolute;
        left: 100%;
        top: 30%;
      }
    }

    .right {
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 7px solid #767B81;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
    }

    .left {
      display: inline-block;
      width: 0;
      height: 0;
      border-right: 7px solid #767B81;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
    }

    &:hover {
      background: #0D94FF;
      border: 1px solid #0D94FF;

      .right {
        border-left: 7px solid #ffffff;
      }

      .left {
        border-right: 7px solid #ffffff;
      }
    }
  }

  .publicright {
    .w(592);
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    justify-content: space-between;
    align-content: space-between;
    transition: 0.3s;
    clear: both;
  }
;

  .subcontainer-one {
    padding: 1.5vh 5.2vw;
    .h(648);
    .w(1194);
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .top {
      width: 100%;
      .h(186);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .plan {
        .w(494);
      }

      .yuan {
        color: #0D94FF;
        background: rgba(13, 148, 255, 0.1);
      }

      .wang {
        color: #5AD8A6;
        background: rgba(90, 216, 166, 0.1);
      }
    }

    .center {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // .h(400);
      .left {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      }

      .right {
        .w(191);
        .h(415);
        display: flex;
        flex-wrap: wrap;

        .plan {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }
      }

      .box {
        .h(193);
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
      }

      .box1 {
        .h(214);
      }

      .jiesuan {
        .w(191);
      }

      .dianl {
        .w(598);

        .item {
          width: auto;

          img {
            width: 279rem;
            height: 151rem;
          }
        }
      }

      .yunwei {
        .w(494);
        background: rgba(38, 154, 153, 0.1);
        color: #269A99;
      }

      .chu {
        .w(294);
      }
    }

    .plan {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      justify-content: center;
      align-items: center;
      // .w(494);
      height: 100%;
      background: rgba(245, 246, 247, 1);
      // background: rgba(13, 148, 255, 0.1);
      border-radius: 16rem;
      color: #cccccc;

      .name {
        // width: 20%;
        font-size: 30px;
        font-weight: 400;
        // line-height: 49px;
      }

      // .top{
      //     .h(184)
      // }
      .cont {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
      }

      .item {
        .w(130);

        img {
          width: 78rem;
          height: 78rem;
        }

        span {
          display: block;
          font-size: 24rem;
        }
      }
    }
  }

  .subcontainer-two {
    .h(648);
    .w(592);
    background: #FFFFFF;
    // box-shadow: 0px 0px 68px 0px rgba(19,28,36,0.24);
    border-radius: 8px;
    position: relative;
  }

  .subcontainer-thr {
    .h(320);
    .w(1194);
    background: #FFFFFF;
  }

  .subcontainer-four {
    .h(320);
    .w(592);
    background: #FFFFFF;
  }
}
</style>